module.exports = __webpack_public_path__ + "static/cadastro_4-3d633597d7bbe149ad446c69473a9a13.png";